import { pipe } from 'ramda';
import {
  ProjectsReportRecord,
  ProjectsReport,
} from 'components/organisms/projects-report/types';
import { Content } from 'stores/core';

const isCompleted = (record: ProjectsReportRecord) => record?.dueDateActual;

export const getProjectRecordsByTemplate = (
  projectsReport: ProjectsReport,
): ProjectsReportRecord[] => {
  const records = pipe(
    () => projectsReport,
    Content.map((x) => x),
    Content.orElse([] as ProjectsReportRecord[]),
  )();

  return records.filter(isCompleted);
};
